import React from 'react';
import styled from 'styled-components';

import Footer from './Footer';
import Wrapper from './Wrapper';
import { DOWNLOAD_URL, FOOTER_TEXT, TITLE, OC_LOGO_URL, WIDGET_DESCRIPTION, WIDGET_IMAGE_URL } from './data';

const Container = styled.div`
  width: 80%;
  margin: auto;
  margin-top: 30px;
  padding-top: 30px;
`;

export default () => (
  <Container>
    <Wrapper
      downloadURL={DOWNLOAD_URL}
      title={TITLE}
      ocLogoURL={OC_LOGO_URL}
      widgetDescription={WIDGET_DESCRIPTION}
      widgetImageURL={WIDGET_IMAGE_URL}
    />
    <Footer text={FOOTER_TEXT} />
  </Container>
);
